/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useState,useCallback,useEffect,useContext} from 'react'
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { DistributorActions } from '../../redux/actions';
import { distributorService } from '../../service/distributor.service';
import Modal from 'react-modal';
import WishlistContext from '../../Components/Context/WishlistContext';
import SidePanelSkeleton from './SidepanelSkeelton';
import CrudModal from './CrudModal';

function WishLayout({children,props}) {
    const [responseNav, setresponseNav] = useState(false)
    const {selectedWishlist,list,setlist,setselectedWishlist,productList,loading,setloading,handleError,handleSuccess,handleRemoveModal,selectedProduct,
        modalType, setmodalType,removeParticular,
        removeAll}=useContext(WishlistContext)

    const handleCreate = async(name,type)=>{
        let message=''
        const payload = {
            "collection_name":name
        }
        let crud;
        if(type==='create'){
            message='created';
            crud = await distributorService.createWishlist(payload);
        }
        if(type==='update'){
            message='updated';
            crud = await distributorService.UpdateWishlist(payload,selectedWishlist.collection_id);
            
        }
        if(type==='delete'){
            message='deleted';
            crud = await distributorService.deleteWishlist(payload,selectedWishlist.collection_id);
        }
        if (!crud?.error && crud.data.success_status) {
            handleSuccess(crud,message)
        } else {
            handleError(crud.message.response.data.message)
        }
    }
    return (
        <div>
            <div className={`md:px-[46px] px-4 sm:py-5 py-3 flex items-center justify-between border-b border-[#A5A5A5] sticky sm:top-[87px] top-[75px]left-0 bg-[#FFFFFF] ${modalType===''?'z-[6]':''}`}>
                <p className="sm:text-xs7 text-base font-semibold text-[#090406] xl:block hidden cursor-pointer">Wishlist</p>
                <div className="dropdown relative xl:hidden block">
                    <button
                        onClick={()=>setresponseNav(!responseNav)}
                        type="button" className="flex items-center dropdown-toggle leading-tight transition duration-150 ease-in-out sm:text-xs7 text-base font-semibold text-[#090406]" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        {selectedWishlist.collection_name}
                        <span>
                            <img src="/images/chevron-down.svg" alt="icon" className="ml-2 w-3 h-3 cursor-pointer" loading="lazy" decoding="async" />
                        </span>
                    </button>
                    <ul className={`dropdown-menu min-w-max absolute bg-clip-padding bg-[#FFFFFF] rounded-lg shadow-xl px-2 py-3 w-[150px] ${responseNav?'show':'hidden'}`} aria-labelledby="dropdownMenuButton1">
                        {list.length>0 && list.map((wishlist,i)=>(
                            <li className="px-1 py-1 cursor-pointer" key={i}
                                onClick={
                                    () => {
                                        setloading(true)
                                        setselectedWishlist({
                                            collection_id:wishlist.collection_id,
                                            collection_name:wishlist.collection_name
                                        });
                                        setresponseNav(false)
                                    }}>
                                <a className="dropdown-item text-sm sm:text-base font-normal text-[#090406]">
                                    {`${wishlist.collection_name.length >15 ? `${wishlist.collection_name.slice(0,15)}...`:wishlist.collection_name}`}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <button type="button" 
                    onClick={()=>setmodalType('create')}
                    className="border border-[#555259] rounded-lg sm:w-[136px] w-[120px] sm:h-10 h-8 sm:text-xs6 text-sm font-semibold text-[#000000]" data-bs-toggle="modal" data-bs-target="#createWishlist">
                    + Create Wishlist
                </button>
            </div>
            <div className='flex overflow-auto' style={{heigh:'80vh',overFlow:'auto'}}>
                <div className="xl:block hidden min-w-[20%] max-w-[20%] bg-[#FFFFFF] pb-[100px] border-r border-[#A5A5A5] fixed h-screen sidebar overflow-auto top-[169px]">
                    <ul>
                        {list.length> 0 ? list.map((whishlist,i)=>(
                            <motion.li
                                key={i} 
                                className={`${selectedWishlist.collection_id===whishlist?.collection_id ? 'bg-[#F5F5FA] border-l-[3px] border-[#ED1C24] ':''} cursor-pointer`}>
                                <div className="py-[18px] pl-10 pr-3 flex justify-between items-center relative">
                                    <span className={`text-xs6 font-semibold text-[#090406] ${selectedWishlist.collection_id===whishlist?.collection_id && whishlist.default===false ? 'w-[60%]' : 'w-full'}`} 
                                        onClick={
                                            () => {
                                                setloading(true)
                                                setselectedWishlist({
                                                    collection_id:whishlist.collection_id,
                                                    collection_name:whishlist.collection_name
                                                })}}>
                                        {selectedWishlist.collection_id===whishlist?.collection_id && whishlist.default===false ? `${whishlist.collection_name}` : `${whishlist.collection_name}`}

                                    </span>
                                    {selectedWishlist.collection_id===whishlist?.collection_id && whishlist.default===false &&(
                                        <div className="flex items-center absolute right-0 pr-1">
                                            <button
                                                onClick={()=>setmodalType('update')}
                                                type="button" className="pr-2.5 border-r border-[#C1C1C1] cursor-pointer flex items-center" data-bs-toggle="modal" data-bs-target="#editWishlist">
                                                <img src="images/edit-2.svg" alt="icon" loading="lazy" decoding="async" className="cursor-pointer w-2 h-2 mr-1" />
                                                <span className="text-xs13 font-semibold text-[#808285]">
                                                    Edit
                                                </span>
                                            </button>
                                            <button
                                                onClick={()=>setmodalType('delete')}
                                                type="button" className="pl-2.5 cursor-pointer flex items-center" data-bs-toggle="modal" data-bs-target="#deleteWishlist">
                                                <img src="images/Icon-feather-trash-2.svg" alt="icon" loading="lazy" decoding="async" className="cursor-pointer w-2 h-2 mr-1" />
                                                <span className="text-xs13 font-semibold text-[#808285]">
                                                    Delete
                                                </span>
                                            </button>
                                        </div>)}
                                </div>
                            </motion.li>
                        )
                        ):<SidePanelSkeleton />}
                
                    </ul>
                </div>
                <>
                    {children}
                    <Outlet/>

                </><Modal isOpen={modalType !==""?true:false}>
                    <CrudModal type={modalType} 
                        handleCreate={handleCreate}
                        handleRemoveModal={handleRemoveModal}
                        selectedProduct={selectedProduct}
                        setmodalType={setmodalType}
                        selectedWishlist={selectedWishlist}
                        removeParticular={removeParticular}
                        handleCrud={handleCreate}
                        removeAll={removeAll} />
                </Modal>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const  { wishList } = state;
    return {wishList}

}
const mapDispatchToProps = {
    getList:DistributorActions.GetWishlist
}

export default connect(mapStateToProps, mapDispatchToProps)(WishLayout)
